import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { SpinnerComponent } from "../../layout/spinner/spinner.component";
import { CommonModule } from '@angular/common';
import { FormBuilder, FormControl, FormGroup, FormsModule, Validators } from '@angular/forms';
import { LanguageService } from 'src/app/services/language/language.service';
import { ToastrService } from 'ngx-toastr';
import { PagesService } from 'src/app/services/pages/pages.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ReactiveFormsModule } from '@angular/forms';
import { EditorModule } from '@tinymce/tinymce-angular';
import { FileManagerComponent } from '../../layout/file-manager/file-manager.component';

import 'tinymce/tinymce.min.js';                    
import 'tinymce/icons/default/icons.min.js';
import 'tinymce/themes/silver/theme.min.js'; 

// საჭიროებისამებრ პლაგინები
import 'tinymce/plugins/link';
import 'tinymce/plugins/lists';
import 'tinymce/plugins/image';
import 'tinymce/plugins/fullscreen';
import { GallerySelectorComponent } from "../../layout/gallery-selector/gallery-selector.component";

import { CdkDragDrop, DragDropModule, moveItemInArray } from '@angular/cdk/drag-drop';

import { ErrorComponent } from "../../layout/error/error.component";

@Component({
  selector: 'app-pages',
  imports: [
    SpinnerComponent,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    EditorModule,
    DragDropModule,

    ErrorComponent
],
  templateUrl: './pages.component.html',
  styleUrl: './pages.component.css'
})
export class PagesComponent {
  data: any
  load = false
  error = false
  loadDeleteId: number | null = null;
  currentLang = 'ge'

  pagination: any = null;
  page: number = 1;
  perPage: number = 20;

  @ViewChild('scrollTarget') scrollTarget: any;
  @ViewChild('addPageModal') addPageModal: any;

  loadSave = false


  selectedPage: any = null;
  @ViewChild('pageFormModal') pageFormModalTemplate!: TemplateRef<any>;

  search: string = '';

  sortColumn: string = '';
  sortDirection: 'asc' | 'desc' = 'asc';


  constructor(
    private langService: LanguageService,
    private ToastrService: ToastrService,
    private PagesService: PagesService,
    private modalService: NgbModal,
  ){

    this.currentLang = this.langService.getLanguage();
    this.langService.currentLanguage$.subscribe((lang) => {
      this.currentLang = lang;
        this.getPage()
    });
    this.getPage()
  }
  
  onPageChange(){
    this.getPage()
  }

  getPage(){
    this.load = true
    this.PagesService.getPages(this.page, this.perPage, this.search).subscribe(
      (res: any) => {
        this.load = false
        this.data = res;
        // console.log(res)
        this.error = false
        window.scrollTo({ top: 0, behavior: 'smooth' });
      },
      (error: any) => {
        this.error = true
        this.load = false
      }
    );
  }

  changePage(newPage: number) {
    this.page = newPage;
    this.getPage();
    if (this.scrollTarget?.nativeElement) {
      this.scrollTarget.nativeElement.scrollIntoView({ behavior: 'smooth' });
    }
  }


  openAddModal() {
    this.selectedPage = null;
    this.modalService.open(this.pageFormModalTemplate, { size: 'lg' });
  }

  editPage(page: any) {
    this.selectedPage = page;
    this.modalService.open(this.pageFormModalTemplate, { size: 'lg' });
  }

  onPageSaved() {
    // this.ToastrService.success('ცვლილება შენახულია წარმატებით');
    this.modalService.dismissAll(); // Close the modal if open
    this.getPage(); // Refresh list
    this.selectedPage = null;
  }

  onCloseModal() {
    this.modalService.dismissAll();
  }


  delete(data: any) {
    if (confirm(`დარწმუნებული ხარ რომ გინდა წაშლა: "${data.title}"?`)) {
      this.loadDeleteId = data.id;
      this.PagesService.deletePage(data.id).subscribe({
        next: () => {
          this.ToastrService.success('გვერდი წარმატებით წაიშალა');
          this.getPage();
          this.loadDeleteId = null;
        },
        error: (err: any) => {
          console.error(err);
          this.ToastrService.error('შეცდომა წაშლისას');
          this.loadDeleteId = null;
        }
      });
    }
  }


  sortData(column: string) {
    if (this.sortColumn === column) {
      // იგივე სვეტზე დაჭერისას მიმართულება იცვლება
      this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
    } else {
      this.sortColumn = column;
      this.sortDirection = 'asc';
    }

    this.data.items = [...this.data.items].sort((a, b) => {
      const valueA = a[column];
      const valueB = b[column];

      if (valueA == null) return 1;
      if (valueB == null) return -1;

      if (valueA < valueB) return this.sortDirection === 'asc' ? -1 : 1;
      if (valueA > valueB) return this.sortDirection === 'asc' ? 1 : -1;
      return 0;
    });
  }

}
